import React from 'react';

export const PersonalEmailLabel: React.FC<{ personalEmail?: string | null }> = ({ personalEmail }) =>
  personalEmail ? (
    <>
      Personal email to <a href={`mailto:${personalEmail}`}>{personalEmail}</a>
    </>
  ) : (
    <>Personal email</>
  );

export const PersonalEmailAndSmsLabel: React.FC<{ personalEmail?: string | null }> = ({ personalEmail }) =>
  personalEmail ? (
    <>
      Personal email &amp; SMS (<a href={`mailto:${personalEmail}`}>{personalEmail}</a>)
    </>
  ) : (
    <>Personal email & SMS</>
  );
